
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import LazyImage from "@src/components/LazyImage";
import ListBox from "@src/components/ListBox";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import {
  harajukuNoodleStandTokyoNoodleStandTopImage,
  harajukuNoodleStandTokyoRiceImage,
} from "@src/constants/images";
import { meta as ramenPageMeta } from "./ramen.mdx";
export const meta = {
  path: "/media/harajuku/noodle_stand_tokyo",
  title: "【原宿】ヌードルスタンド東京でヘルシーなココナッツラーメンを食べよう！",
  description: "原宿でヘルシーなラーメンが食べられるヌードルスタンド(Noodle Stand Tokyo)についてご紹介します！ヘルシーなラーメンだけでなく、食材へのこだわり、アクセス、雰囲気などをまとめてみました！原宿で普段とは違ったヘルシーなラーメンを食べてみたい方は、ヌードルスタンドのこの記事をチェックしてみてください！",
  topImg: harajukuNoodleStandTokyoNoodleStandTopImage,
  author: murakamiMasanori,
  tags: ["ラーメン", "有名店", "おしゃれな内装", "あっさり", "人気店", "お店の紹介", "1人メシ"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿でヘルシーなラーメンが食べられるヌードルスタンド(Noodle Stand Tokyo)についてご紹介します！`}</p>
    <p>{`ヘルシーな COCONUT 味噌ラーメンや、ヴィーガン向けのメニューが食べられるお店として原宿でも人気店です。
テレビ、雑誌、youtube などでは、「牛煮込みまぜそば」などのこってりしたメニューも紹介されていますが、今回はヘルシーなラーメンの方をご紹介させていただきます！`}</p>
    <p>{`食材へのこだわり、アクセス、雰囲気などもまとめてみましたので、ヌードルスタンドに行きたい方、ヘルシーなラーメンに興味がある方はチェックしてください！`}</p>
    <h2>{`ラーメンなのにヘルシー`}</h2>
    <InstaImage postId="BwVl77pAxje" mdxType="InstaImage" />
    <p>{`ラーメンといえば、「こってりで脂っこい」「食べた後に胃もたれする」など、
ヘルシーよりはハイカロリーなイメージが強いのではないでしょうか。
こんなラーメンの常識を覆してくれるのが、原宿でよくメディアにも取り上げられている`}<strong parentName="p">{`ヌードルスタンド`}</strong>{`(Noodle Stand Tokyo)になります！`}</p>
    <h3>{`天然素材を使った創作ラーメン`}</h3>
    <p>{`素材にこだわった料理を提供したいというコンセプトを大事にしていて、ヌードルスタンド(Noodle Stand Tokyo)HP で詳細の情報が見れるようになっています！`}</p>
    <h4>{`ヌードルスタンド(Noodle Stand Tokyo)のこだわり`}</h4>
    <ListBox list={["化学調味料を一切使わない", "使用原材料の産地を全て公開", "低糖質の麺が食べられる"]} mdxType="ListBox" />
    <hr></hr>
    <h2>{`原宿駅から徒歩１分でアクセス抜群`}</h2>
    <p>{`ヌードルスタンド(Noodle Stand Tokyo)は、原宿駅の竹下口から`}<strong parentName="p">{`徒歩１分`}</strong>{`という好立地！
休日は人混みにつかまってしまうと、５分程度かかる可能性もありますが、比較的短い時間で到着できます。`}</p>
    <GoogleMap lat={35.672298} lng={139.7013333} mdxType="GoogleMap" />
    <h3>{`地下につながる入り口を探してください！`}</h3>
    <p>{`ヌードルスタンドに到着しても「見つけられない」「場所が分からない！」といった方もたくさんいらっしゃるそうなので、こちらの外観を探してください。`}</p>
    <InstaImage postId="BxjOxC8pJ8P" exclude={[8]} mdxType="InstaImage" />
    <h3>{`階段を降りると店の入り口を発見できます`}</h3>
    <p>{`バーのようなおしゃれな入り口を開けるとヌードルスタンドの店内になります！`}</p>
    <InstaImage postId="Bm9w0pDlO00" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`店内はカフェのような雰囲気`}</h2>
    <h3>{`照明がお店全体の雰囲気を演出`}</h3>
    <InstaImage postId="BwUVy_ZBKa1" exclude={[3]} mdxType="InstaImage" />
    <p>{`ヌードルスタンドの店内は、天井の電球がむき出しの状態で出ていて、それがお店全体に落ち着いた雰囲気を演出しています！`}</p>
    <h3>{`おしゃれな壁紙`}</h3>
    <InstaImage postId="BlpfZYXFaDl" mdxType="InstaImage" />
    <p>{`お客様が持ってきたシールをお店の額縁に飾っていくという取り組みなどもやっていたりするそうです！`}</p>
    <h3>{`ゆったりできるカウンター席`}</h3>
    <p>{`ラーメン屋といえば、「硬い椅子に座って狭い席で食べる」のようなイメージですが、ヌードルスタンド(Noodle Stand Tokyo)ではカウンター席でゆったりできます。
皮張りのカウンター席は席も広く、厨房も覗きながら、自分のラーメンができるのを待つと楽しいです！`}</p>
    <hr></hr>
    <h2>{`ヘルシーな人気メニュー`}</h2>
    <h3>{`COCONUT 味噌ラーメン(1,120 円)`}</h3>
    <InstaImage postId="BnXpgllFoZJ" exclude={[2, 3, 4]} mdxType="InstaImage" />
    <h4>{`スーパーフードを使用`}</h4>
    <p>{`ヌードルスタンドでは、`}<strong parentName="p">{`Brown Sugar Ast.`}</strong>{`さんが提供する、`}<strong parentName="p">{`100%エキストラバージンココナッツオイル`}</strong>{`を使用してラーメンを作っています！
まじりっけのないないココナッツと白味噌なのに驚くほど`}<strong parentName="p">{`ヘルシーなラーメン`}</strong>{`を味わってみてください１`}</p>
    <h4>{`麺が選べる！？`}</h4>
    <p>{`COCONUT 味噌ラーメンは、ローカーボ麺が使用されていて、そのままでもかなりヘルシーなラーメンになっています！
もっと素材の味が気になる方は、ヘルシーな`}<strong parentName="p">{`グルテンフリー麺`}</strong>{`も選んで食べることができます！`}</p>
    <hr></hr>
    <h4>{`ヴィーガン COCONUT 味噌ラーメン(1,120 円)`}</h4>
    <InstaImage postId="BhiRqwJlUTR" mdxType="InstaImage" />
    <p>{`外国人や一部の女性に大人気なのが、`}<strong parentName="p">{`ヴィーガン向けの COCONUT`}</strong>{`味噌ラーメンになります！
基本のベースは COCONUT 味噌ラーメンになっており、チャーシューを`}<strong parentName="p">{`ソイミート`}</strong>{`をブレンドして作り上げています。`}</p>
    <p>{`ヌードルスタンドではトッピングもできるようになっており、
`}<strong parentName="p">{`パクチー`}</strong>{`をトッピングして食べると、さらに一味違った味になるので、クセになってしまいます！`}</p>
    <hr></hr>
    <h2>{`平日の 11 時~14 時はあのメニューが無料で！？`}</h2>
    <LazyImage img={harajukuNoodleStandTokyoRiceImage} mdxType="LazyImage" />
    <h3>{`お米マイスターが作るご飯が一杯無料`}</h3>
    <p>{`平日のランチタイムの`}<strong parentName="p">{`11:00~14:00`}</strong>{`の間だと、お米マイスターが作るお米が一杯無料で食べられることでお得です！
普通だと一杯 200 円してしまいます。
ラーメンに合う`}<strong parentName="p">{`あきたこまち`}</strong>{`は粒がしっかりしていて、ラーメンのダシと合わせて食べたりなんかすると美味しそうですよね！`}</p>
    <hr></hr>
    <h2>{`気になる待ち時間(行列情報)`}</h2>
    <p>{`ヌードルスタンドでは、席数が`}<strong parentName="p">{`11 席`}</strong>{`と少ないため、お昼時は平日・休日問わず行列ができやすいです！
休日だと、30 分程度待たないといけない日もあるそう…。`}</p>
    <p>{`行列を割ける狙い目の時間は、ランチ前の 11:30 頃か、ランチ後の 13:30 頃が狙い目になりそうです！`}</p>
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`いかがでしたでしょうか。今回はヌードルスタンド東京のお店のコンセプト、雰囲気、ヘルシーラーメンについてご紹介してきました！
ヌードルスタンドにお越しの際は、是非チェックしてみてください！`}</p>
    <hr></hr>
    <p>{`他のラーメンが気になる方はこちらの記事がオススメ！`}</p>
    <LinkWithThumbnail meta={ramenPageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;